<div class="video-card-container p-3 pb-0 landingpageservices-container-height1">
    <div class="row mb-3">
        <div class="d-flex align-items-center justify-content-space-between pe-2">
            <h3 class="text-center library-heading">Video Library</h3>
            <button mat-mdc-raised-button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-bottom--xs"
                (click)="navigateToAllVideoPage()">View All</button>
        </div>
    </div>
    <div class="row d-flex video-card-container-row">
        <div 
            class="mb-4 home-video-library" 
            *ngFor="let video of allVideos; let i = index" 
            [ngClass]="{
                'col-md-6': allVideos.length === 2,
                'col-md-4': allVideos.length === 3,
                'col-md-3': allVideos.length >= 4
            }">
            <app-video-card [video]="video" [isHomePage]="isHomePage" [index]="i+100" (mediaReady)="onVideoCardReady(i)"></app-video-card>         
        </div>
        <div class="d-flex justify-content-center align-items-center"
            *ngIf="allVideos?.length === 0">
            <p class="text-center">No videos available at the moment.</p>
        </div>
       
    </div>
</div>